import React from 'react';
import { actionIcons, icons } from '../../../../../../configs/Icons';

function NotificationSection() {
    return (
        <div className="header-notification relative flex flex-row justify-center items-center ">
            <button type="button" className="h-7 w-7 md:w-6 md:h-6 cursor-pointer">
                <img src={actionIcons.bellW} alt="" />
            </button>
            <div className="absolute top-0.5 right-[7px] md:top-[2px] md:right-1">
                <img src={icons.bellDotW} alt="" />
            </div>
        </div>
    );
}

export default NotificationSection;
